import { Component, Input } from '@angular/core';
import { Insured } from '../../models/models';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-user-initials',
  templateUrl: './user-initials.component.html',
  styleUrls: ['./user-initials.component.scss'],
})
export class UserInitialsComponent {
  @Input() member: Insured;
  @Input() size: 'md' | 'lg' = 'md';
  @Input() showEmail: boolean = true;
  env = environment;

  getBackgroundFromInitials(): string {
    // List of 5 light pastel colors
    const colors = [
      '#fbe1e7', // Pink
      '#fff6cc', // Gold
      '#d7ffd7', // PaleGreen
      '#bcf1fb', // LightSkyBlue
      '#ffd3c0', // LightSalmon
    ];
    const charCode = this.member.firstname.charCodeAt(0) + this.member.lastname.charCodeAt(0);
    return colors[charCode % colors.length];
  }

}
